import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box, HStack, IconButton, Icon } from '@chakra-ui/react';
import { Bars3Icon } from '@heroicons/react/24/outline';

interface Props {
  id: string;
  isOverlay?: boolean;
  content: React.JSX.Element;
}

const SortableItem: React.FC<Props> = ({ id, isOverlay = false, content }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

  const style = {
    transform: isOverlay ? undefined : CSS.Transform.toString(transform),
    transition: isOverlay ? undefined : transition,
  };

  return (
    <Box
      ref={setNodeRef}
      style={style}
      p={1}
      bg={isOverlay ? 'bg.subtle' : 'bg.subtle'}
      borderRadius={'md'}
      _hover={{ bg: 'border' }}
      w={'full'}
    >
      <HStack>
        <IconButton
          aria-label={'Drag handle'}
          cursor={'grab'}
          variant={'ghost'}
          {...listeners}
          {...attributes}
          disabled={isOverlay}
        >
          <Icon as={Bars3Icon} h={4} w={4} />
        </IconButton>
        <Box width='full'>{content}</Box>
      </HStack>
    </Box>
  );
};

export default SortableItem;
